var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1334_121887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1334_121887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5V15.5C10.5 15.9167 10.6458 16.2708 10.9375 16.5625C11.2292 16.8542 11.5833 17 12 17C12.4167 17 12.7708 16.8542 13.0625 16.5625C13.3542 16.2708 13.5 15.9167 13.5 15.5V14.5H14.5C14.9167 14.5 15.2708 14.3542 15.5625 14.0625C15.8542 13.7708 16 13.4167 16 13C16 12.5833 15.8542 12.2292 15.5625 11.9375C15.2708 11.6458 14.9167 11.5 14.5 11.5H13.5V10.5C13.5 10.0833 13.3542 9.72917 13.0625 9.4375C12.7708 9.14583 12.4167 9 12 9C11.5833 9 11.2292 9.14583 10.9375 9.4375C10.6458 9.72917 10.5 10.0833 10.5 10.5V11.5H9.5C9.08333 11.5 8.72917 11.6458 8.4375 11.9375C8.14583 12.2292 8 12.5833 8 13C8 13.4167 8.14583 13.7708 8.4375 14.0625C8.72917 14.3542 9.08333 14.5 9.5 14.5H10.5ZM6 21C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19V10C4 9.68333 4.07083 9.38333 4.2125 9.1C4.35417 8.81667 4.55 8.58333 4.8 8.4L10.8 3.9C11.15 3.63333 11.55 3.5 12 3.5C12.45 3.5 12.85 3.63333 13.2 3.9L19.2 8.4C19.45 8.58333 19.6458 8.81667 19.7875 9.1C19.9292 9.38333 20 9.68333 20 10V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H6Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5V15.5C10.5 15.9167 10.6458 16.2708 10.9375 16.5625C11.2292 16.8542 11.5833 17 12 17C12.4167 17 12.7708 16.8542 13.0625 16.5625C13.3542 16.2708 13.5 15.9167 13.5 15.5V14.5H14.5C14.9167 14.5 15.2708 14.3542 15.5625 14.0625C15.8542 13.7708 16 13.4167 16 13C16 12.5833 15.8542 12.2292 15.5625 11.9375C15.2708 11.6458 14.9167 11.5 14.5 11.5H13.5V10.5C13.5 10.0833 13.3542 9.72917 13.0625 9.4375C12.7708 9.14583 12.4167 9 12 9C11.5833 9 11.2292 9.14583 10.9375 9.4375C10.6458 9.72917 10.5 10.0833 10.5 10.5V11.5H9.5C9.08333 11.5 8.72917 11.6458 8.4375 11.9375C8.14583 12.2292 8 12.5833 8 13C8 13.4167 8.14583 13.7708 8.4375 14.0625C8.72917 14.3542 9.08333 14.5 9.5 14.5H10.5Z",
    fill: "#053692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHospital);
export default __webpack_public_path__ + "static/media/icon_hospital.8612679140df6d658ec86a1ff607bd42.svg";
export { ForwardRef as ReactComponent };